var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5 170.688C132.548 170.688 170.688 132.548 170.688 85.5002C170.688 38.4523 132.548 0.3125 85.5 0.3125C38.4521 0.3125 0.312195 38.4523 0.312195 85.5002C0.312195 132.548 38.4521 170.688 85.5 170.688Z",
    fill: "#F7B01A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.353 80.2275C126.29 84.6673 129.343 89.9395 128.51 96.0441C127.4 104.924 124.348 103.536 121.018 108.253C117.688 112.971 117.966 117.688 113.803 120.74C109.641 123.793 106.866 120.74 102.427 120.74C99.3742 120.74 96.5994 120.74 93.8245 120.74L97.4318 104.646L113.803 96.3216L119.353 80.2275Z",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.213 145.422C101.339 145.977 91.0719 170.673 84.6897 169.563C69.7055 166.788 67.7631 137.93 54.1664 146.255C73.5903 134.045 79.9725 122.391 70.2605 110.182C79.9725 122.391 90.5169 113.789 99.6739 110.182C90.2394 122.668 96.0666 133.213 115.213 145.422Z",
    fill: "#F2C296"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.763 73.8313C120.763 95.7525 101.339 119.061 84.6897 119.061C68.0406 119.061 48.6167 95.7525 48.6167 73.8313V51.6325C48.6167 29.7113 64.9883 11.6748 84.6897 11.6748C104.391 11.6748 120.763 29.7113 120.763 51.6325V73.8313Z",
    fill: "#FFD0A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2331 63.5781C76.343 63.3006 76.6205 62.7457 76.0655 61.9132C75.5106 60.8033 69.9609 59.1384 67.741 58.5834C64.1337 58.0284 59.4164 58.5834 56.6416 60.2483C56.3641 60.5258 56.3641 60.8033 56.6416 61.0808C59.6939 60.5258 63.3012 60.5258 67.186 61.0808C69.6834 61.6357 72.4582 62.4682 75.2331 63.5781ZM92.1596 62.7457C91.0497 62.4682 90.7722 61.9132 91.0497 61.3582C91.6047 60.2483 97.1544 58.5834 99.3742 58.0284C102.982 57.4735 107.699 58.0284 110.474 59.6933C110.751 59.9708 110.751 60.2483 110.474 60.5258C107.421 59.9708 103.814 59.9708 99.9292 60.5258C97.7093 61.0808 94.9345 61.6357 92.1596 62.7457Z",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1073 34.7198C78.0079 33.6098 55.8091 50.5364 51.6468 67.7404C46.3746 86.3318 48.0395 75.2324 48.0395 82.7245C48.0395 90.2166 44.1548 84.3894 49.427 88.8292C52.7568 91.8815 54.1442 97.1537 53.3118 104.923C53.3118 100.761 52.2018 97.4312 49.427 94.9338C45.2647 91.049 42.4898 87.9967 39.4375 83.557C33.8878 75.7874 34.1653 48.594 46.3746 32.7774C58.584 16.9608 74.4006 9.1912 92.1596 12.2435C109.919 15.2959 120.463 34.1648 122.683 47.2065C124.903 60.2483 124.903 70.2377 122.683 75.2324C120.463 80.2272 118.798 78.0073 118.798 78.0073C118.798 78.0073 115.191 56.641 109.364 49.4264C103.536 42.2118 98.5418 34.7198 89.1073 34.7198Z",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5576 31.1123C78.2854 28.6149 72.4582 30.5573 66.3535 37.4944C53.5892 51.9236 52.2018 60.8031 47.762 68.5726M85.5 28.3374C90.7722 25.8401 96.5993 27.7825 102.704 34.7196C115.468 49.1488 116.856 57.7508 121.295 65.5203",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5576 31.1123C78.2854 28.6149 72.4582 30.5573 66.3535 37.4944C53.5892 51.9236 52.2018 60.8031 47.762 68.5726M85.5 28.3374C90.7722 25.8401 96.5994 27.7825 102.704 34.7196C115.468 49.1488 116.856 57.7508 121.295 65.5203",
    stroke: "#1C151F",
    strokeOpacity: 0.25,
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 22.788C92.1596 18.3482 98.2643 19.4581 104.369 26.3952C117.133 40.8244 114.913 39.437 119.353 47.2066M83.5576 27.7827C76.343 24.4529 68.5734 26.9502 60.8038 35.5522C42.2123 55.5311 43.5998 55.2536 39.4375 62.7457",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 22.788C92.1596 18.3482 98.2643 19.4581 104.369 26.3952C117.133 40.8244 114.913 39.437 119.353 47.2066M83.5576 27.7827C76.343 24.4529 68.5734 26.9502 60.8038 35.5522C42.2123 55.5311 43.5998 55.2536 39.4375 62.7457",
    stroke: "#1C151F",
    strokeOpacity: 0.25,
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5576 21.9557C73.8456 17.516 64.9661 19.7358 56.919 28.0604C38.3275 48.0392 44.9872 39.4372 40.5474 46.9293M122.683 89.9393C124.625 95.2115 124.07 99.3738 121.018 102.149C116.301 106.311 112.971 106.311 112.139 110.196C111.306 114.08 107.976 117.41 106.311 117.41",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5576 21.9557C73.8456 17.516 64.9661 19.7358 56.919 28.0604C38.3275 48.0392 44.9872 39.4372 40.5474 46.9293M122.683 89.9393C124.625 95.2115 124.07 99.3738 121.018 102.149C116.301 106.311 112.971 106.311 112.139 110.196C111.306 114.08 107.976 117.41 106.311 117.41",
    stroke: "#1C151F",
    strokeOpacity: 0.25,
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8606 87.7608C67.6191 87.7608 69.8554 86.0215 69.8554 83.876C69.8554 81.7305 67.6191 79.9912 64.8606 79.9912C62.1021 79.9912 59.8659 81.7305 59.8659 83.876C59.8659 86.0215 62.1021 87.7608 64.8606 87.7608Z",
    fill: "#F29976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.206 87.7608C108.964 87.7608 111.201 86.0215 111.201 83.876C111.201 81.7305 108.964 79.9912 106.206 79.9912C103.447 79.9912 101.211 81.7305 101.211 83.876C101.211 86.0215 103.447 87.7608 106.206 87.7608Z",
    fill: "#F29976"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.48 72.8589C75.0301 74.4859 72.0385 76.4039 68.4218 76.303C65.3571 76.2601 60.9264 73.2833 61.3473 71.9324C61.5212 70.2764 65.8348 69.0553 68.8995 69.0983C71.7172 68.8362 75.9299 71.232 75.48 72.8589Z",
    fill: "#FFE7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4218 76.3023C70.4033 76.5105 72.1783 75.0729 72.3864 73.0915C72.5946 71.11 71.157 69.335 69.1755 69.1269C67.194 68.9187 65.419 70.3563 65.2109 72.3377C65.0028 74.3192 66.4404 76.0942 68.4218 76.3023Z",
    fill: "#482811"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1396 71.7006C64.4689 66.1217 69.5234 65.8155 74.5791 70.8112C75.0731 71.4212 75.5381 72.3071 75.7851 72.6121C75.0151 71.9732 74.7391 71.9442 74.7391 71.9442C74.7391 71.9442 71.6593 69.3884 68.3187 69.3164C64.978 69.2445 60.8535 71.3226 60.7955 71.8746C60.9265 73.2835 65.1682 75.4033 64.8922 75.3743C62.1905 74.5324 60.0696 73.4725 59.1396 71.7006Z",
    fill: "#3E3226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8538 71.3221C59.9969 71.5111 59.1689 71.4241 58.646 71.0902C58.094 71.0322 57.382 69.8413 57.498 68.7373C59.9099 72.3391 61.8266 70.0291 61.8266 70.0291C61.8266 70.0291 61.5217 70.2761 60.8538 71.3221Z",
    fill: "#3E3226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1026 70.0585C60.9408 70.4945 60.3888 70.4365 59.8659 70.1026C59.0669 69.7396 58.6019 68.8537 58.4419 67.7207C60.8538 71.3225 62.7705 69.0125 62.7705 69.0125C62.7705 69.0125 62.7416 69.2885 62.1026 70.0585Z",
    fill: "#3E3226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3617 74.3606C94.0876 75.8841 97.367 77.2524 100.911 76.5244C103.921 75.9494 107.766 72.2486 107.117 70.9917C106.658 69.3916 102.198 68.9393 99.1877 69.5142C96.3675 69.746 92.6358 72.837 93.3617 74.3606Z",
    fill: "#FFE7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.911 76.5246C98.996 77.074 96.9983 75.9672 96.4489 74.0524C95.8994 72.1375 97.0063 70.1399 98.921 69.5905C100.836 69.0411 102.833 70.148 103.383 72.0628C103.932 73.9776 102.826 75.9752 100.911 76.5246Z",
    fill: "#482811"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.251 70.3801C103.033 65.8139 98.0029 66.3911 93.8931 72.1882C93.5128 72.8746 93.2089 73.8277 93.0187 74.1709C93.6658 73.408 93.9325 73.3315 93.9325 73.3315C93.9325 73.3315 96.5209 70.2799 99.7979 69.6284C103.075 68.9769 107.498 70.3058 107.651 70.8392C107.767 72.2491 103.959 75.0734 104.225 74.9969C106.739 73.6984 108.643 72.2862 109.251 70.3801Z",
    fill: "#3E3226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.499 70.3059C108.375 70.343 109.175 70.1135 109.632 69.6938C110.166 69.5407 110.66 68.2445 110.354 67.1777C108.605 71.143 106.316 69.202 106.316 69.202C106.316 69.202 106.659 69.3922 107.499 70.3059Z",
    fill: "#3E3226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.049 69.2788C107.269 69.5061 107.802 69.3531 108.259 68.9333C108.983 68.4371 109.287 67.4841 109.247 66.3408C107.499 70.3061 105.21 68.3651 105.21 68.3651C105.21 68.3651 105.286 68.6318 106.049 69.2788Z",
    fill: "#3E3226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4492 77.8436C49.7266 82.8384 51.1141 87.5556 48.6167 87.8331C45.2869 88.1106 40.0147 82.8384 39.7372 77.5662C39.4597 72.294 41.1246 68.4092 43.8995 68.4092C46.6743 68.4092 49.1717 72.5714 49.4492 77.8436Z",
    fill: "#FFD0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1717 75.0686C49.1717 75.0686 45.2869 68.409 41.6796 75.6236M47.7842 73.9587C47.7842 73.9587 43.8994 76.7335 43.3445 82.5607",
    stroke: "#CE9F75",
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.972 77.8436C119.694 82.8384 118.307 87.5556 121.082 87.8331C124.412 88.1106 129.684 82.8384 129.961 77.5662C130.239 72.5714 128.574 68.4092 125.799 68.4092C122.747 68.4092 120.249 72.5714 119.972 77.8436Z",
    fill: "#FFD0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.804 75.0686C120.804 75.0686 124.689 68.409 128.296 75.6236M122.192 73.9587C122.192 73.9587 126.077 76.7335 126.632 82.5607",
    stroke: "#CE9F75",
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8731 135.155V135.433C68.8731 140.15 76.3652 143.757 85.5222 143.757C94.6792 143.757 102.171 140.15 102.171 135.433C102.171 135.433 102.171 135.433 102.171 135.155C102.449 135.155 102.726 135.155 103.004 135.155C109.941 136.543 119.375 142.925 119.375 142.925C119.375 142.925 129.642 150.695 129.642 156.522C129.642 159.852 110.496 170.396 84.6897 170.396C58.8836 170.396 40.5696 160.129 40.5696 156.522C40.5696 150.695 50.5591 143.202 50.5591 143.202C50.5591 143.202 60.826 136.265 68.0406 134.878C68.3181 135.155 68.5956 135.155 68.8731 135.155Z",
    fill: "#F2C296"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.037 165.057C107.981 168.42 97.2931 171 84.763 171C72.6013 171 61.5453 168.052 54.1581 165.265C54.1581 164.987 54.1581 164.833 54.1581 164.555C54.1581 157.063 51.6607 150.126 47.7759 145.964C49.4408 144.299 50.8283 143.189 50.8283 143.189C50.8283 143.189 61.0952 136.252 68.3098 134.864C68.5873 134.864 68.8648 134.864 68.8648 134.864V135.142C68.8648 139.859 76.3569 143.466 85.5139 143.466C94.6709 143.466 102.163 139.859 102.163 135.142C102.163 135.142 102.163 135.142 102.163 134.864C102.44 134.864 102.718 134.864 102.995 134.864C109.933 136.252 119.367 142.634 119.367 142.634C119.367 142.634 120.754 143.744 122.697 145.409C118.812 149.848 116.037 156.508 116.037 164.278C116.037 164.833 116.037 165.057 116.037 165.057Z",
    fill: "#3B2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1295 63.0088L86.0771 67.726L86.3546 87.1499L92.1818 85.7625L91.0719 91.0347L87.7421 92.4221",
    stroke: "#3B2D41",
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0332 98.1855L73.6458 99.8505M94.7347 98.1855L96.1221 99.8505",
    stroke: "#3B2D41",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2897 99.0176C93.6247 100.96 89.4625 102.347 84.7452 102.347C80.028 102.347 76.1432 100.96 74.2008 99.0176",
    stroke: "#3B2D41",
    strokeWidth: 1.88235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7828 69.8689H88.2749M51.3694 66.5391H78.0079C79.9503 68.4815 81.0603 69.8689 81.0603 70.9788C81.0603 72.6437 76.0655 83.7431 72.1807 83.7431C68.296 83.7431 61.9138 83.7431 58.584 83.7431C55.2542 83.7431 51.3694 73.1987 51.3694 70.9788C51.3694 69.5914 51.3694 68.204 51.3694 66.5391ZM117.966 66.5391H91.3272C89.3848 68.4815 88.2749 69.8689 88.2749 70.9788C88.2749 72.6437 93.2696 83.7431 97.1544 83.7431C101.039 83.7431 107.421 83.7431 110.751 83.7431C114.081 83.7431 117.966 73.1987 117.966 70.9788C117.966 69.5914 117.966 68.204 117.966 66.5391Z",
    stroke: "#353535",
    strokeWidth: 3.76471
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitSecond);
export default __webpack_public_path__ + "static/media/benefit_second.6f7f81ab5dc86f571f50ba00c551bca2.svg";
export { ForwardRef as ReactComponent };